export default __webpack_public_path__ + "static/media/Archpriest's Straps of Balance.50cc4a29.jpg";